<template>
    <div class="message">
        <div class="message-option" @click="alarmDetailed(item)" v-for="(item,index) in alarmList" :key="index">
        <img class="message-img" :src="imgUrls[item.type]" background-size="cover" />
        <div class="message-card">
            <div class="card-top">
            <p>{{item.title}}</p>
            <span>{{item.createTime?item.createTime:''}}</span>
            </div>
            <div class="card-bottom">{{item.content?item.content:textContent[item.type]}}</div>
        </div>
        <div v-show="item.readStatus" class="hint"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "message",
    data() {
        return {
            imgUrls: {
                'fenceAlarm':require('@/assets/images/designated.png'),
                'sosAlarm':require('@/assets/images/sosmessage.png'),
                'deviceAlarm':require('@/assets/images/equipmentnews.png')
            },
            textContent: {
                'fenceAlarm':'暂无预警提醒信息',
                'sosAlarm':'暂无SOS提醒信息',
                'deviceAlarm':'暂无设备提醒消息'
            },
            imei:'',//设备imei
            alarmList:[],//消息列表
        };
    },
    created() {
        this.getMessageList()
    },
    watch: {
    },
    methods: {
        /**
         * 获取消息列表
         */
        getMessageList(){
            let data = {
                ver:1,
                method:'getAlarmHomePage'
            }
            this.$http.get(this.$api.userInfo.POST_APPLET,data).then(res => {
                if (res.code === 0) {
                    let  formatNumber = (n)=> {
                        const str = n.toString()
                        return str[1] ? str : `0${str}`
                    }
                    let formatTime = (date)=> {
                        let a = date.replace(/\.|\-/g, '/')
                        date = new Date(a)
                        const year = date.getFullYear()
                        const month = date.getMonth() + 1
                        const day = date.getDate()

                        const hour = date.getHours()
                        const minute = date.getMinutes()
                        const second = date.getSeconds()
                        const t1 = [year, month, day].map(formatNumber).join('-')
                        const t2 = [hour, minute].map(formatNumber).join(':')
                        return `${t1} ${t2}`
                    }
                    res.data.forEach((item,index) => {
                        if(item.createTime){
                            res.data[index].createTime = formatTime(item.createTime)
                        }
                    });
                    this.alarmList = res.data
                } else {
                    this.$toast({
                        message: res.msg,
                        duration: 2000,
                        icon: require('@/assets/images/safety-fence/wrong.png'),
                    });
                }
            })
        },
        /**
         * 查看消息详情
         */
        alarmDetailed(obj){
        let typeObj = {
            'fenceAlarm':'fence',
            'sosAlarm':'SOS',
            'deviceAlarm':'device'
        },navObj={
            'fenceAlarm':'designatedArea',//指定区域进出提醒
            'sosAlarm':'sosMessage', //SOS告警提醒
            'deviceAlarm':'deviceAlarm' //设备消息
        }
        this.$router.push({name:obj.type , query: { data: typeObj[obj.type] }})
        },
    },
    mounted() {
    },
};
</script>

<style  lang='scss' scoped>
.message{
  background: #F8F8F8;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.message .message-option{
  width: 670px;
  height: 190px;
  padding: 0 32px;
  background: #FFFFFF;
  border-radius: 20px;
  margin-top: 25px;
  display: flex;
  align-items: center;
  position: relative;
}
.hint{
  position: absolute;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: red;
  left: 90px;
  top: 55px;
}
.message-img{
  width: 80px;
  height: 80px;
}
.message-card{
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-left: 40px;
}
.card-top{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}
.card-top>p{
  font-size: 30px;
  font-weight: 600;
  color: #000000;
}
.card-top>span{
  font-size: 26px;
  font-family: ArialMT;
  color: #999999;
}
.card-bottom{
  font-size: 26px;
  font-weight: 400;
  color: #999999;
}
</style>